import { dashboardPath } from "../path";

export const getStartedPath = `${dashboardPath}/get-started`;
